module.exports = __webpack_public_path__ + "static/img/74c0fbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/bdyxgg/txgg_khzb.png
// module id = 629
// module chunks = 2